import fragment from 'graphql/fragments/product/DeadStockLineFragment.graphql';

import workspaceQuery from 'graphql/queries/product/DeadStockLineWorkspaceQuery.graphql';

const DeadStock = {
  type: 'DeadStockLine',
  title: 'Dead Stock Lines',
  workspaceUrl: '/Products/DeadStockLine/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'PRODUCT_DEAD_STOCK',
  operations: 0,
};

export default DeadStock;
